import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Measure from 'react-measure';

import styles from './map.module.scss';

const cx = classnames.bind(styles);

function Map({ background, backgroundColor, children, isCurrent, padding, identifier }) {
  const [dimensions, setDimensions] = useState(null);

  const mapStyle = {};

  if (backgroundColor) {
    mapStyle.backgroundColor = backgroundColor;
  }

  const imageStyle = {};

  if (padding) {
    imageStyle.padding = padding;
  }

  return (
    <Measure
      bounds
      onResize={(contentRect) => {
        setDimensions(contentRect.bounds);
      }}
    >
      {({ measureRef }) => (
        <section className={cx({ map: true, current: isCurrent })} style={mapStyle}>
          <div className={styles['image-container']} ref={measureRef}>
            <img
              className={styles['background-image']}
              src={background}
              alt="background image"
              style={imageStyle}
            />
          </div>
          {identifier && identifier}
          {React.Children.map(children, (child) => {
            return React.cloneElement(child, { dimensions });
          })}
        </section>
      )}
    </Measure>
  );
}

Map.propTypes = {
  background: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  isCurrent: PropTypes.bool,
  padding: PropTypes.string,
  identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Map;
